import { combineReducers } from "redux";
import {
  SEARCH_GET_ENTITY_OBJECT_SUCCESS,
  SEARCH_GET_ENTITY_OBJECT_ERROR,
  SEARCH_RECEIVE_CITY_ERROR,
  SEARCH_RECEIVE_CITY_SUCCESS,
  SEARCH_GET_ENTITY_SUCCESS,
  SEARCH_GET_ENTITY_ERROR,
  SEARCH_GET_ENTITY_OBJECT_REQUEST,
  SEARCH_GET_OBJECT_SUCCESS,
  SEARCH_GET_OBJECT_ERROR,
  SEARCH_GET_ENTITY_REQUEST,
  SEARCH_GET_OBJECT_REQUEST,
  SEARCH_RECEIVE_COMPANY_ERROR,
  SEARCH_RECEIVE_COMPANY_SUCCESS,
  SEARCH_RECEIVE_CITY_REQUEST,
  SEARCH_RECEIVE_PURPOSE_REQUEST,
  SEARCH_RECEIVE_PURPOSE_SUCCESS,
  SEARCH_RECEIVE_PURPOSE_ERROR, SEARCH_PURPOSE_CLEAR
} from '../../../common/constants/action-constants';
import { PurposesState } from '../../../common/components/purpose-autucomplete/usePurposes';
import { PurposeActions } from '../actions/search';

const initialState = {
  isFetching: false,
};

const initialStatePurpose: PurposesState = {
  items: [],
  loading: false,
  error: null,
  lastQuery: "",

}

const receiveSearchProcessing = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_GET_ENTITY_OBJECT_REQUEST:
    case SEARCH_GET_ENTITY_REQUEST:
    case SEARCH_GET_OBJECT_REQUEST:
    case SEARCH_RECEIVE_CITY_REQUEST:
      return {
        isFetching: true,
      };
    case SEARCH_GET_ENTITY_OBJECT_SUCCESS:
    case SEARCH_GET_ENTITY_SUCCESS:
    case SEARCH_GET_OBJECT_SUCCESS:
    case SEARCH_RECEIVE_CITY_SUCCESS:
      return {
        isFetching: false,
      };

    default:
      return state;
  }
};

const receiveSearchResult = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_GET_ENTITY_OBJECT_SUCCESS:
      return action.result;

    default:
      return state;
  }
};

const receiveSearchEntitiesResult = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_GET_ENTITY_SUCCESS:
      return action.result;

    default:
      return state;
  }
};

const receiveSearchObjectsResult = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_GET_OBJECT_SUCCESS:
      return action.result;

    default:
      return state;
  }
};

const receiveSearchCitiesResult = (state = [], action) => {
  switch (action.type) {
    case SEARCH_RECEIVE_CITY_SUCCESS:
      return action.result;

    default:
      return state;
  }
};

const receiveSearchCompany = (state = [], action) => {
  switch (action.type) {
    case SEARCH_RECEIVE_COMPANY_SUCCESS:
      return action.companies;

    default:
      return state;
  }
};

const errorSearchResult = (state = {}, action) => {
  switch (action.type) {
    case SEARCH_GET_ENTITY_OBJECT_ERROR:
    case SEARCH_GET_ENTITY_ERROR:
    case SEARCH_GET_OBJECT_ERROR:
    case SEARCH_RECEIVE_CITY_ERROR:
    case SEARCH_RECEIVE_COMPANY_ERROR:
      return action.error;

    default:
      return state;
  }
};

const receiveSearchPurposeResult = (state = initialStatePurpose, action: PurposeActions): PurposesState => {
  switch (action.type) {
      case SEARCH_RECEIVE_PURPOSE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          lastQuery: action.requestData.inputValue,
        };
      case SEARCH_RECEIVE_PURPOSE_SUCCESS:
        return {
          ...state,
          loading: false,
          items: action.items,
          lastQuery: action.query,
        };
      case SEARCH_RECEIVE_PURPOSE_ERROR:
        return {
           ...state,
           loading: false,
           error: action.error,
        };
      case SEARCH_PURPOSE_CLEAR:
        return {
          ...state,
          items: [],
          lastQuery: "",
        };
      default:
        return state;
  }
}

const searchResult = combineReducers({
  receiveSearchProcessing,
  receiveSearchResult,
  receiveSearchCitiesResult,
  receiveSearchCompany,
  entitiesResult: receiveSearchEntitiesResult,
  objectsResult: receiveSearchObjectsResult,
  error: errorSearchResult,
  receiveSearchPurposeResult,
});

export default searchResult;
